import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import cardFeesFormMeta, { ICardFeesFormMeta } from "./cardFeesFormMeta";
import cardProgramFormMeta, { ICardProgramFormMeta } from "./cardProgramFormMeta";
import magneticTapeApplicationFormMeta, { IMagneticTapeApplicationFormMeta } from "./magneticTapeApplication/magneticTapeApplicationFormMeta";

export interface ICardProductFormMeta extends ICardProgramFormMeta, IMagneticTapeApplicationFormMeta, ICardFeesFormMeta {
    
    schema: any;
}

let cardProductFormMeta = {} as ICardProductFormMeta;

cardProductFormMeta = {...cardProductFormMeta, ...cardProgramFormMeta, ...magneticTapeApplicationFormMeta, ...cardFeesFormMeta};

cardProductFormMeta.schema = yup.object().shape(getValidationSchema(cardProductFormMeta));

export default cardProductFormMeta;
